import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";

const CashFlowItemDetailMain = () => {
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={"Name"} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={"Unique code"} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={"Type"} fieldName={"belongTo"} items={EnumHelper.AccrualDetailBelongToTypeEnum()} />
        </Col>
      </Row>
    </>
  );
};

export default CashFlowItemDetailMain;
